import React, { Component } from 'react';
import KuposModal from './KuposModal';
import SvgHome from './SvgHome';
import PropTypes from 'prop-types';
import { KuposButton } from '.';

export default class AtTimeInfoModal extends Component {
  static propTypes = {
    image: PropTypes.object.isRequired,
    t: PropTypes.func,
  };

  render() {
    return (
      <div className="common-bip-info-modal">
        <KuposModal
          showModal={this.props.showModal}
          onHide={this.props.onHide}
          size="md"
          ariaLabel="login-modal"
        >
          <div className="bip-info-modal-container">
            <div className="close-button pointer" onClick={this.props.onHide}>
              <SvgHome name="close" />
            </div>
            <div
              className="kupos-pool-popup-image-back"
              style={{ textAlign: 'center', marginTop: 10 }}
            >
              <span>{this.props.timeInfo}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
              <KuposButton onClick={this.props.onHide} className="bip-button-inner">
                {this.props.t('HOME.OK_CONTINUE')}
              </KuposButton>
            </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/AtTimeInfoModal.js